import { useState, type FormEvent } from 'react';
import { sx } from '../sx';
import { useApp } from '../state';

export function SignIn() {
  const { orgName, signIn } = useApp();
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      await signIn(id, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'That user ID or password is not recognised.');
      setPassword('');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div
      style={sx(
        'flex:1;display:flex;align-items:center;justify-content:center;padding:24px;min-height:100vh;box-sizing:border-box;background:radial-gradient(900px 420px at 50% 0%,#1c6f63,#0d3b35 60%),#0d3b35',
      )}
    >
      <div style={sx('width:100%;max-width:410px;perspective:1400px')}>
        <form
          onSubmit={submit}
          style={sx(
            'background:linear-gradient(180deg,#ffffff,#f5f9f8);border-radius:14px;padding:32px 28px;box-sizing:border-box;border-top:1px solid #ffffff;box-shadow:0 1px 0 #fff inset,0 44px 70px -34px rgba(0,0,0,.7),0 10px 20px -12px rgba(0,0,0,.45);transform:rotateX(1.6deg)',
          )}
        >
          <div
            style={sx(
              'width:44px;height:44px;border-radius:11px;background:linear-gradient(160deg,#1a6a5e,#0b332d);box-shadow:0 8px 16px -8px rgba(13,59,53,.8),0 1px 0 rgba(255,255,255,.35) inset;display:flex;align-items:center;justify-content:center;margin-bottom:16px',
            )}
          >
            <div
              style={sx(
                'width:20px;height:20px;border-radius:5px;border:2px solid #c9a227;border-top-color:#7fd0c0;transform:rotate(45deg)',
              )}
            />
          </div>
          <div
            style={sx(
              'font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#5a6b68;font-weight:600',
            )}
          >
            {orgName}
          </div>
          <div
            style={sx(
              "font-family:'IBM Plex Serif',serif;font-size:21px;font-weight:700;line-height:1.3;margin:8px 0 4px",
            )}
          >
            Progress Monitoring System
          </div>
          <div style={sx('font-size:13px;color:#5a6b68;line-height:1.5;margin-bottom:24px')}>
            Mitigation of Waterlogging in District Rahim Yar Khan (PIAIP)
          </div>
          <div style={sx('display:flex;flex-direction:column;gap:14px')}>
            <div style={sx('display:flex;flex-direction:column;gap:6px')}>
              <label
                htmlFor="pms-user"
                style={sx(
                  'font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#5a6b68;font-weight:600',
                )}
              >
                User ID
              </label>
              <input
                id="pms-user"
                name="username"
                type="text"
                autoComplete="username"
                autoCapitalize="none"
                autoFocus
                value={id}
                onChange={(e) => {
                  setId(e.target.value);
                  setError('');
                }}
                style={sx(
                  'padding:12px;border:1px solid #d3dcda;border-radius:7px;font-size:15px;width:100%;box-sizing:border-box;background:#fff;box-shadow:0 1px 2px rgba(13,59,53,.08) inset',
                )}
              />
            </div>
            <div style={sx('display:flex;flex-direction:column;gap:6px')}>
              <label
                htmlFor="pms-pass"
                style={sx(
                  'font-size:11px;letter-spacing:.08em;text-transform:uppercase;color:#5a6b68;font-weight:600',
                )}
              >
                Password
              </label>
              <input
                id="pms-pass"
                name="password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setError('');
                }}
                style={sx(
                  'padding:12px;border:1px solid #d3dcda;border-radius:7px;font-size:15px;width:100%;box-sizing:border-box;background:#fff;box-shadow:0 1px 2px rgba(13,59,53,.08) inset',
                )}
              />
            </div>
            {error ? (
              <div
                role="alert"
                style={sx('background:#fbeae7;color:#a3372c;border-radius:6px;padding:9px 11px;font-size:13px')}
              >
                {error}
              </div>
            ) : null}
            <button
              type="submit"
              disabled={busy}
              className="pms-btn-3d"
              style={sx(
                'background:linear-gradient(180deg,#14766a,#0d4a42);color:#fff;border:0;padding:14px;border-radius:8px;font-size:15px;font-weight:600;cursor:pointer;width:100%;box-shadow:0 1px 0 rgba(255,255,255,.25) inset,0 10px 18px -10px rgba(13,59,53,.9)',
              )}
            >
              {busy ? 'Signing in…' : 'Sign in'}
            </button>
          </div>
          <div
            style={sx(
              'margin-top:22px;border-top:1px solid #eef2f1;padding-top:14px;font-size:12px;color:#5a6b68;line-height:1.6',
            )}
          >
            Use the account issued to you by the Project Management Unit. If a password has been
            forgotten, the System Administrator can reset it.
          </div>
        </form>
      </div>
    </div>
  );
}
